import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from '../../../components/AppIcon';

const cities = [
  { name: 'Mumbai',     properties: '12,400+', img: '/assets/images/cities/mumbai.webp' },
  { name: 'Delhi NCR',  properties: '9,800+',  img: '/assets/images/cities/delhi.webp' },
  { name: 'Bangalore',  properties: '8,200+',  img: '/assets/images/cities/bangalore.webp' },
  // Charminar — Hyderabad (verified Apr 2026)
  { name: 'Hyderabad',  properties: '5,600+',  img: '/assets/images/cities/hyderabad.webp' },
  // Shaniwar Wada with Indian flag — Pune (verified Apr 2026)
  { name: 'Pune',       properties: '4,300+',  img: '/assets/images/cities/pune.webp' },
  // Marina Beach — Chennai
  { name: 'Chennai',    properties: '3,900+',  img: '/assets/images/cities/chennai.webp' },
  // Howrah Bridge — Kolkata
  { name: 'Kolkata',    properties: '3,100+',  img: '/assets/images/cities/kolkata.webp' },
  // Bara Imambara clock tower — Lucknow (verified Apr 2026)
  { name: 'Lucknow',    properties: '2,400+',  img: '/assets/images/cities/lucknow.webp' },
];

// Deterministic rose gradient per city — used when an Unsplash URL 404s.
const cityGradients = [
  'from-rose-500 via-rose-400 to-orange-300',
  'from-pink-500 via-rose-400 to-amber-300',
  'from-rose-600 via-pink-500 to-rose-300',
  'from-fuchsia-500 via-rose-500 to-orange-400',
  'from-rose-500 via-red-400 to-yellow-300',
  'from-pink-600 via-rose-400 to-rose-200',
  'from-rose-500 via-orange-400 to-amber-300',
  'from-rose-600 via-fuchsia-500 to-pink-300',
];

const CityCard = ({ city, gradient, onClick }) => {
  const [imageFailed, setImageFailed] = useState(false);

  return (
    <button
      onClick={onClick}
      className="group relative rounded-xl overflow-hidden aspect-[4/3] bg-gray-100 text-left"
    >
      {imageFailed ? (
        <div className={`w-full h-full bg-gradient-to-br ${gradient} flex items-center justify-center`}>
          <Icon name="Building2" size={36} className="text-white/40" />
        </div>
      ) : (
        <img
          src={city.img}
          alt={city.name}
          width="400"
          height="300"
          loading="lazy"
          onError={() => setImageFailed(true)}
          className="w-full h-full object-cover group-hover:scale-105 transition duration-300"
        />
      )}
      <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent" />
      <div className="absolute bottom-0 left-0 right-0 p-3">
        <h3 className="text-white font-semibold text-sm lg:text-base">{city.name}</h3>
        <p className="text-white/80 text-xs inline-flex items-center gap-1">Explore rentals →</p>
      </div>
    </button>
  );
};

const SearchSection = () => {
  const navigate = useNavigate();

  return (
    <section className="py-10 sm:py-14 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-8 sm:mb-10">
          <h2 className="text-2xl lg:text-3xl font-bold text-gray-900 mb-2">Explore by City</h2>
          <p className="text-gray-500 max-w-lg mx-auto">Browse rental properties in India's most popular cities in your nearby areas</p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4">
          {cities.map((city, i) => (
            <CityCard
              key={city.name}
              city={city}
              gradient={cityGradients[i % cityGradients.length]}
              onClick={() => navigate(`/advanced-search-discovery?q=${encodeURIComponent(city.name)}`)}
            />
          ))}
        </div>

        <div className="text-center mt-8">
          <button
            onClick={() => navigate('/advanced-search-discovery')}
            className="text-rose-500 hover:text-rose-600 font-medium text-sm inline-flex items-center gap-1 transition"
          >
            View all cities <Icon name="ArrowRight" size={16} />
          </button>
        </div>
      </div>
    </section>
  );
};

export default SearchSection;
